import { render, staticRenderFns } from "./BTableOKUCollectorPublications.vue?vue&type=template&id=2258e235&"
import script from "./BTableOKUCollectorPublications.vue?vue&type=script&lang=js&"
export * from "./BTableOKUCollectorPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports